import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { EFoldersListComponent } from './e-folders-list/e-folders-list.component';
import { EFoldersListFiltersComponent } from './e-folders-list-filters/e-folders-list-filters.component';
import { EAbsenceConclusionsListComponent } from './e-absence-conclusions-list/e-absence-conclusions-list.component';
import { EAbsenceConclusionsListFiltersComponent } from './e-absence-conclusions-list-filters/e-absence-conclusions-list-filters.component';
import { EOthersListComponent } from './e-others-list/e-others-list.component';
import { EOthersListFiltersComponent } from './e-others-list-filters/e-others-list-filters.component';
import { EDocumentationService } from '../data/e-documentation-service';
import { VirtualScrollModule } from '../virtual-scroll/virtual-scroll.module';
import { AddEDocumentFormComponent } from './add-e-document-form/add-e-document-form.component';
import { EDocumentDetailsComponent } from './e-document-details/e-document-details.component';
import { SignModalComponent } from './sign-modal/sign-modal.component';
import { EDocumentBuforFiltersComponent } from './edocument-bufor-filters/e-document-bufor-filters.component';
import { EDocumentBuforComponent } from './edocument-bufor/e-document-bufor.component';
import { EFolderValidationDetailsComponent } from './e-folder-validation-details/e-folder-validation-details.component';
import { EFoldersUcpListComponent } from './e-folders-ucp-list/e-folders-ucp-list.component';
import { EFoldersUcpListFiltersComponent } from './e-folders-ucp-list-filters/e-folders-ucp-list-filters.component';
import { EDocumentsListComponent } from './e-documents-list/e-documents-list.component';
import { EDocumentsListFiltersComponent } from './e-documents-list-filters/e-documents-list-filters.component';
import { EFoldersComponent } from './e-folders/e-folders.component';
import { SettingsComponent } from './settings/settings.component';
import { DocumentPermissionSettingsComponent } from './document-permission-settings/document-permission-settings.component';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop'



@NgModule({
  declarations: [
    EFoldersListComponent,
    EFoldersListFiltersComponent,
    EAbsenceConclusionsListComponent,
    EAbsenceConclusionsListFiltersComponent,
    EOthersListComponent,
    EOthersListFiltersComponent,
    EDocumentBuforComponent,
    EDocumentBuforFiltersComponent,
    AddEDocumentFormComponent,
    EDocumentDetailsComponent,
    SignModalComponent,
    EFolderValidationDetailsComponent,
    EFoldersUcpListComponent,
    EFoldersUcpListFiltersComponent,
    EDocumentsListComponent,
    EDocumentsListFiltersComponent,
    EFoldersComponent,
    SettingsComponent,
    DocumentPermissionSettingsComponent
  ],
  imports: [
    SharedModule,
    VirtualScrollModule,
    CdkDropList,
    CdkDrag
  ],
  providers: [
    EDocumentationService
  ],
  exports: [
    EFoldersListComponent,
    EAbsenceConclusionsListComponent,
    EOthersListComponent,
    EDocumentBuforComponent,
    EFoldersUcpListComponent,
    EFoldersComponent,
    SettingsComponent,
    DocumentPermissionSettingsComponent
  ]
})
export class EDocumentationModule { }
